/* eslint-disable */
import { Theme, createStyles, makeStyles } from "@material-ui/core";

export const styles = (theme: Theme) =>
  createStyles({
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      paddingBottom: theme.spacing(2),
    },
    headerTitle: {
      fontWeight: "bold",
      fontSize: "16px",
      lineHeight: "24px",
    },
    filterIcon: {
      width: "16px",
      height: "16px",
      cursor: "pointer",
      fill: "#8F8F8F",
      margin: "0 0 0 16px",
    },
  });

export const useStyles = makeStyles(styles);
